import { capitalizeFirstLetter } from 'src/utils/string';

const matchesSearch = (text, query) => {
  if (!query || !text) return !query;
  const normalizedText = String(text);
  const normalizedQuery = String(query);

  return normalizedText
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .includes(
      normalizedQuery
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
    );
};

const createLookupModel = (label, value, requestChange, errors = null) => ({
  label: capitalizeFirstLetter(label || ''),
  value,
  requestChange,
  ...(errors && { errors }),
});

const LookupField = ({
  Component,
  multi,
  clearable,
  model,
  data,
  podeEditar,
  abrirEmDrawer,
  compactMulti,
  disabled = false,
}) => (
  <div>
    <Component
      multi={multi}
      clearable={clearable}
      disabled={disabled}
      model={model}
      {...(data && { data })}
      {...(abrirEmDrawer !== undefined && { abrirEmDrawer })}
      {...(compactMulti !== undefined && { compactMulti })}
      {...(podeEditar !== undefined && { podeEditar })}
    />
  </div>
);

export { matchesSearch, createLookupModel, LookupField };
